/** Ids that are in the current feed and still unread — used for the bell decrement. */
export default function unreadIdsInFeed(items = [], notificationIDS = []) {
  return notificationIDS.filter((id) => {
    const item = items.find((entry) => entry._id === id);
    return Boolean(item) && !item.read;
  });
}

/** Ids that may be marked: unread in the feed, or not loaded yet. */
export function markableNotificationIds(items = [], notificationIDS = []) {
  return notificationIDS.filter((id) => {
    const item = items.find((entry) => entry._id === id);
    return !item || !item.read;
  });
}
